import { useMemo, createContext, useContext } from 'react';
export const DropEventListContext = createContext(null);
export function useDropEventListContext() {
    const context = useContext(DropEventListContext);
    if (!context) {
        throw new Error('useDropEventListContext must be used within DropEventListContext');
    }
    return context;
}
export function DropEventListContextProvider(props) {
    const contextValue = useMemo(() => {
        return {
            dropEvent: props.dropEvent,
        };
    }, [props.dropEvent]);
    return (<DropEventListContext.Provider value={contextValue}>
			{props.children}
		</DropEventListContext.Provider>);
}
